import useConfig from "src/hooks/useConfig"
import { AvatarCard } from "../../components/views/avatars/components/avatar-card"
import {
  AvatarCard as UttaCard,
  AvatarCardProps
} from "../../components/views/avatars/components/avatar-card-utta"

function ConditionalAvatarCard(props: AvatarCardProps) {
  const config = useConfig()
  switch (config.platformName) {
    case "LearnMachine":
    case "Utta":
      return <UttaCard {...props} />
    default:
      return <AvatarCard {...props} />
  }
}

export default ConditionalAvatarCard
